import React from 'react';
import 'common/Spinner.css';

const Spinner = () => {
  return (
    <div class='sk-chase sk-center'>
      <div class='sk-chase-dot'></div>
      <div class='sk-chase-dot'></div>
      <div class='sk-chase-dot'></div>
      <div class='sk-chase-dot'></div>
      <div class='sk-chase-dot'></div>
      <div class='sk-chase-dot'></div>
    </div>
  );
};

export default Spinner;
